import { vesselRules } from './vessels.js';
/**
 * Пять боссов «Экспедиции» (SPEC.md, раздел 15.5). Числа стартовые — настраиваются на плейтестах.
 * Имена, портреты и дразнилки — в клиенте.
 */
export const BOSS_IDS = ['spornitsa', 'grippozavr', 'vibrion', 'tuberkul', 'chimera'];
const ability = (kind, name, options) => ({
    kind,
    name,
    every: null,
    belowHp: null,
    count: 0,
    duration: 0,
    ...options,
});
const base = {
    body: null,
    parts: [],
    partDamage: 0,
    damage: 1,
    chainBonus: 1,
    guards: 0,
};
export const BOSS_LEVELS = {
    /** Спорница — королева плесени в Банке, тело 2 × 2 в сосуде. */
    spornitsa: {
        id: 'spornitsa',
        vessel: 'jar',
        virusCount: 10,
        boss: {
            ...base,
            id: 'spornitsa',
            placement: 'vessel',
            hp: 10,
            body: { x: 3, y: 9, width: 2, height: 2 },
            abilities: [
                ability('replicate', 'Размножение', { every: 5, count: 2 }),
                ability('raise-floor', 'Подъём дна', { every: 4, belowHp: 3, count: 4 }),
            ],
        },
    },
    /** Гриппозавр — за стеклом Пробирки. */
    grippozavr: {
        id: 'grippozavr',
        vessel: 'tube',
        virusCount: 14,
        boss: {
            ...base,
            id: 'grippozavr',
            placement: 'outside',
            hp: 14,
            abilities: [
                ability('mutate', 'Мутация', { every: 4, count: 3 }),
                ability('storm', 'Цитокиновый шторм', { belowHp: 7, duration: 4 }),
            ],
        },
    },
    /** Вибрион-Спрут — за стеклом Чашки Петри, в чашке 4 щупальца. */
    vibrion: {
        id: 'vibrion',
        vessel: 'petri',
        virusCount: 14,
        boss: {
            ...base,
            id: 'vibrion',
            placement: 'hybrid',
            hp: 12,
            damage: 0,
            chainBonus: 0,
            parts: [
                { x: 1, y: 6 },
                { x: 4, y: 9 },
                { x: 7, y: 9 },
                { x: 10, y: 6 },
            ],
            partDamage: 3,
            abilities: [
                ability('fog', 'Токсин', { every: 6, count: 3, duration: 3 }),
                ability('regrow', 'Отращивание', { every: 5, belowHp: 6 }),
            ],
        },
    },
    /** Туберкул — в Колбе, тело 2 × 3, три сторожевых микроба в «Биоплёнке». */
    tuberkul: {
        id: 'tuberkul',
        vessel: 'flask',
        virusCount: 16,
        boss: {
            ...base,
            id: 'tuberkul',
            placement: 'vessel',
            hp: 16,
            body: { x: 4, y: 11, width: 2, height: 3 },
            guards: 3,
            abilities: [ability('latency', 'Латентность', { belowHp: 8, duration: 3, count: 5 })],
        },
    },
    /** Химера — финальный босс Биореактора, три фазы. */
    chimera: {
        id: 'chimera',
        vessel: 'bioreactor',
        virusCount: 18,
        boss: {
            ...base,
            id: 'chimera',
            placement: 'outside',
            hp: 20,
            abilities: [
                ability('replicate', 'Репликация', { every: 5, count: 2 }),
                ability('mutate', 'Мутация', { every: 5, belowHp: 14, count: 3 }),
                ability('storm', 'Цитокиновый шторм', { every: 6, belowHp: 6, duration: 3 }),
            ],
        },
    },
};
/** Правила боя с боссом: сосуд главы + босс + стартовые вирусы. */
export function bossRules(id) {
    const level = BOSS_LEVELS[id];
    return { ...vesselRules(level.vessel), virusCount: level.virusCount, boss: level.boss };
}
//# sourceMappingURL=bosses.js.map